<template>
  <div id="importExamZIP">
    <ots-main-title></ots-main-title>

    <div class="mainCon mainBox">
      <el-form>
        <el-form-item label="考试批次：" >
          <el-select v-model="planId" placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 导入数据包 -->
        <el-form-item label="压缩包（zip）：">
          <el-upload
            action=""
            ref="upload"
            :multiple="multiple"
            :limit="limit"
            :http-request="httpRequest"
            :show-file-list="true"
            :before-upload="beforeUpload"
          >
            <template v-if="isHasSlot">
              <slot></slot>
            </template>
            <div v-else class="default-upload-container">{{ getFileName }}</div>
          </el-upload>
        </el-form-item>

        <el-button type="primary" round plain @click="importZip" style="margin-top: 16px;"> 导入作答记录 </el-button>
        <el-button type="primary" round @click="search" style="margin-top: 16px;"> 查询 </el-button>
      </el-form>
    </div>

    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableData="tableData"
    ></ots-table-group-new>

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { uploadExamPackageByBatchAPI, queryExamSubmitNumAPI } from "@/http/modules/computedRoomExam";
export default {
  name: "importExamZIP",
  data() {
    return {
      options: [],
      planId: '',

      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
      ],

      // 导入文件相关
      multiple: false,
      limit: 1,
      file: "",
      name: "点击选择文件",
      fileType: "zip",

      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "回收试卷数",
          prop: "returnAnswerNum"
        },
        {
          title: "交卷数",
          prop: "submitOtsAnswerNum"
        },
        {
          title: "OTS阅卷成绩回传数",
          prop: "setScoreByOTSNum"
        }
      ],
      tableData: [],
      currentPlan: {},
    }
  },
  computed: {
    isHasSlot() {
      return this.$slots.default && this.$slots.default.length;
    },
    getFileName() {
      if (this.multiple) {
        let newName = this.name.replace(/点击选择文件/g, "");
        return this.name === "点击选择文件" ? this.name : newName.substring(0, newName.lastIndexOf("、"));
      } else {
        return this.name;
      }
    },
  },
  watch: {
    planId: function(val) {
      for (let key in this.options) {
        if (this.options[key].id == val) {
          this.currentPlan = this.options[key];
          break;
        }
      }
      this.tableData = [];
      this.search();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    async search() {
      const { code, data } = await queryExamSubmitNumAPI({planId: this.planId});
      if (code == 1) {
        data.planName = this.currentPlan.name;
        this.tableData.push(data);
      }
    },
    // 批次
    async initData() {
      const { data: planList } = await getSelectPlanFn({needAudit: 12});
      this.options = planList;
      this.planId = planList[0].id;
    },
    // 执行导入
    async importZip() {
      if (!this.file) {
        this.$message.error("请选择压缩包文件！");
        return;
      }
      const formData = new FormData();
      let params = {
        file: this.file,
        planId: this.planId
      }
      for (let item in params) {
        formData.append(item, params[item]);
      }
      const res = await uploadExamPackageByBatchAPI(formData);
      if (res.code == 1) {
        this.$message.success("机考数据导入成功！");
      }
    },
    httpRequest(val) {
      this.file = val.file;
    },
    beforeUpload(file) {
      let isType = true;
      if (this.fileType) {
        isType = file.name.indexOf(this.fileType) > -1;
      }
      const isLimit = Math.floor(file.size / 1024 / 1024) < 10;
      if (!isType) {
        this.$message.error(`只能上传${this.fileType}文件!`);
      } else if (!isLimit) {
        this.$message.error("上传的压缩包文件大小不能超过 10M!");
      }
      let isOk = isType && isLimit;
      if (isOk) {
        this.name = file.name;
      }
      this.$refs.upload.clearFiles();
      return isOk;
    },
    clearFileName() {
      this.name = "点击选择文件";
    },
  }
}
</script>

<style lang="less" scoped>
.default-upload-container {
  box-sizing: border-box;
  width: 240px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  background: rgba(255, 255, 255, 0.35);
  color: #c2c4cc;
  font-size: 13px;
  line-height: 36px;
  text-align: left;
  padding-left: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>